<template>
  <div>
    <load-profile />
    <b-card id="container" ref="container">
      <b-card-text class="mb-2">
        <h5>
          {{ $t('pages.chatAssignment.desc') }}
        </h5>
      </b-card-text>
      <div class="d-flex flex-row mb-4">
        <div
          class="d-flex flex-row flex-item--half border rounded px-2 py-2 mr-4 justify-content-between"
          :class="isManual ? 'border-primary' : ''"
          @click="isManual = true"
        >
          <div class="d-flex flex-column">
            <h4>{{ $t('pages.chatAssignment.options.manual.title') }}</h4>
            <span>{{ $t('pages.chatAssignment.options.manual.desc') }}</span>
          </div>
          <b-form-checkbox v-model="isManual" @change="isManual = true" />
        </div>
        <div
          class="d-flex flex-row border flex-item--half rounded px-2 py-2 justify-content-between"
          :class="isAuto ? 'border-primary' : ''"
          @click="isAuto = true"
        >
          <div class="d-flex flex-column">
            <h4>{{ $t('pages.chatAssignment.options.auto.title') }}</h4>
            <span>{{ $t('pages.chatAssignment.options.auto.desc') }} </span>
          </div>
          <b-form-checkbox v-model="isAuto" @change="isAuto = true" />
        </div>
      </div>
      <div class="d-flex flex-row mb-4 mr-4">
        <div
          class="d-flex flex-row flex-item--half border rounded px-2 py-2 justify-content-between"
          :class="isAutoRanking ? 'border-primary' : ''"
          @click="isAutoRanking = true"
        >
          <div class="d-flex flex-column">
            <h4>{{ $t('pages.chatAssignment.options.autoRanking.title') }}</h4>
            <span>{{
              $t('pages.chatAssignment.options.autoRanking.desc')
            }}</span>
          </div>
          <b-form-checkbox
            v-model="isAutoRanking"
            @change="isAutoRanking = true"
          />
        </div>
      </div>
      <div class="d-flex flex-row justify-content-end">
        <b-button variant="primary" @click="updateAssignment">
          {{ $t('button.saveChanges') }}
        </b-button>
      </div>
    </b-card>

    <div>
      <b-card id="container" ref="container">
        <b-card-text class="mb-2">
          <h5>
            {{ $t('pages.chatAssignment.botDesc') }}
          </h5>
        </b-card-text>
        <b-form-checkbox
          v-model="bot"
          name="summary-toggle"
          switch
          @input="changeBotEnable"
        >
          <p class="font-weight-bold">
            {{ $t(`pages.chatSettings.ticketEditor.enable.${bot}`) }}
          </p>
        </b-form-checkbox>
        <div class="d-flex flex-row mb-1 mt-2">
          <!-- the basic bot -->
          <div
            class="d-flex flex-row border rounded px-2 py-2 mr-4 justify-content-between select-item"
            :class="isBasicBot ? 'border-primary' : ''"
            :disabled="!bot"
            @click="!bot ? '' : (isBasicBot = true)"
          >
            <div class="d-flex flex-column">
              <h4>
                {{ $t('pages.chatAssignment.options.bot.title') }}
              </h4>
              <span>{{ $t('pages.chatAssignment.options.bot.desc') }}</span>
            </div>
            <b-form-checkbox
              v-model="isBasicBot"
              @change="isBasicBot = true"
              :disabled="!bot"
            />
          </div>
        </div>
        <div class="d-flex flex-row mb-1">
          <div
            class="d-flex flex-column border rounded px-2 py-2 mb-4 select-item"
            :class="isAdvancedBot ? 'border-primary' : ''"
            @click="!bot ? '' : (isAdvancedBot = true)"
          >
            <div class="d-flex justify-content-between align-items-start mb-2">
              <div class="flex-grow-1">
                <h4>
                  {{ $t('pages.chatAssignment.options.advancedBot.title') }}
                </h4>
                <span>{{
                  $t('pages.chatAssignment.options.advancedBot.desc')
                }}</span>
              </div>
              <b-form-checkbox
                v-model="isAdvancedBot"
                @change="isAdvancedBot = true"
                :disabled="!bot"
              />
            </div>

            <div v-if="isAdvancedBot">
              <!-- Number inputs section -->
              <div class="row">
                <div class="col-12 col-md-6 col-lg-4 mb-1">
                  <label for="numberOfTrendTopic">{{
                    $t('number_of_trend_topics')
                  }}</label>
                  <b-form-input
                    id="numberOfTrendTopic"
                    v-model.number="numberOfTrendTopic"
                    type="number"
                    min="1"
                    :placeholder="$t('enter_trend_topics')"
                  />
                </div>
                <div class="col-12 col-md-6 col-lg-4 mb-2">
                  <label for="numberOfTrendChatAgent">{{
                    $t('number_of_trend_chat_agents')
                  }}</label>
                  <b-form-input
                    id="numberOfTrendChatAgent"
                    v-model.number="numberOfTrendChatAgent"
                    type="number"
                    min="1"
                    :placeholder="$t('enter_trend_agents')"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <b-card-text class="mb-2">
          <h5>
            {{ $t('pages.chatAssignment.autoAssignOperatorDesc') }}
          </h5>
        </b-card-text>
        <b-form-checkbox
          v-model="autoAssignOperatorIfBotFails"
          name="auto-assign-toggle"
          switch
        >
          <p class="font-weight-bold">
            {{ $t(`pages.chatSettings.ticketEditor.enable.${autoAssignOperatorIfBotFails}`) }}
          </p>
        </b-form-checkbox>

        <div class="d-flex flex-row justify-content-end">
          <b-button
            variant="primary"
            @click="updateAssignment"
            :disabled="
              (bot && !isAdvancedBot && !isBasicBot) || !isValidAdvancedBot
            "
          >
            {{ $t('button.saveChanges') }}
          </b-button>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
  import {
    BCard,
    BCardText,
    BFormCheckbox,
    BButton,
    BFormInput,
    BFormTextarea
  } from 'bootstrap-vue';
  import Repository from '@/repositories/RepositoryFactory';
  import ChatAssignmentRespository from '@/repositories/Api/ChatAssignmentRespository';
  import TextEditor from './ChatAssignmentTextEditor.vue';

  const ChatAssignmentRepository = Repository.get('chatAssignmentRepository');

  export const BOT_TYPE = { BASIC: 'basic', ADVANCED: 'advanced' };

  export default {
    components: {
      BCard,
      BCardText,
      BFormCheckbox,
      BButton,
      BFormInput,
      BFormTextarea,
      TextEditor
    },
    data: () => ({
      isManual: false,
      isAuto: true,
      isAutoRanking: false,
      bot: false,
      isBasicBot: false,
      isAdvancedBot: false,
      allocateByTopic: false,
      manualDesc: '',
      autoDesc: '',
      numberOfTrendTopic: 2,
      numberOfTrendChatAgent: 2,
      autoAssignOperatorIfBotFails: false,
    }),
    watch: {
      isManual(newValue, oldValue) {
        if (newValue) {
          this.isAuto = oldValue;
          this.isAutoRanking = oldValue;
        }
      },
      isAuto(newValue, oldValue) {
        if (newValue) {
          this.isAutoRanking = oldValue;
          this.isManual = oldValue;
        }
      },
      isAutoRanking(newValue, oldValue) {
        if (newValue) {
          this.isManual = oldValue;
          this.isAuto = oldValue;
        }
      },
      isBasicBot(newValue, oldValue) {
        if (newValue) {
          this.isAdvancedBot = oldValue;
        }
      },
      isAdvancedBot(newValue, oldValue) {
        if (newValue) {
          this.isBasicBot = oldValue;
        }
      }
    },
    computed: {
      isValidAdvancedBot() {
        if (!this.isAdvancedBot) return true;
        return (
          this.numberOfTrendTopic >= 0 &&
          this.numberOfTrendChatAgent >= 0
        );
      }
    },
    async mounted() {
      await this.getAssignment();
    },
    methods: {
      async getAssignment() {
        try {
          const response = await ChatAssignmentRepository.show();
          const { data } = response.data;
          console.log(data, 'get data');
          const {
            auto,
            manual,
            autoDescription,
            manualDescription,
            autoRanking,
            bot,
            botType,
            numberOfTrendTopic,
            numberOfTrendChatAgent,
            numberOfFrequentlyTopicSendToRag,
            autoAssignOperatorIfBotFails
          } = data;
          this.isAuto = auto;
          this.isManual = manual;
          this.autoDesc = autoDescription;
          this.manualDesc = manualDescription;
          this.isAutoRanking = autoRanking;
          this.bot = bot;
          this.autoAssignOperatorIfBotFails = autoAssignOperatorIfBotFails || false;
          if (bot) {
            if (botType === BOT_TYPE.ADVANCED) {
              this.isAdvancedBot = true;
              this.numberOfTrendTopic = numberOfTrendTopic || 2;
              this.numberOfTrendChatAgent = numberOfTrendChatAgent || 2;
              this.numberOfFrequentlyTopicSendToRag =
                numberOfFrequentlyTopicSendToRag || 2;
            } else {
              this.isBasicBot = true;
            }
          }

        } catch (err) {
          const { data } = err.response;
          const { message } = data;
          if (message === 'error.recordNotFound') await this.createAssignment();
        }
      },
      async createAssignment() {
        try {
          const payload = {
            manual: this.isManual,
            manualDescription:
              'Operators assign themselves to selected conversations.',
            auto: this.isAuto,
            autoDescription:
              'Operators are assigned automatically to conversations evenly in sequential order.'
          };
          const response = await ChatAssignmentRepository.create(payload);
          await this.getAssignment();
        } catch (err) {
          alert(err);
        }
      },
      async updateAssignment() {
        try {
          const payload = {
            manual: this.isManual,
            manualDescription: this.manualDesc,
            auto: this.isAuto,
            autoDescription: this.autoDesc,
            autoRanking: this.isAutoRanking,
            bot: this.bot,
            autoAssignOperatorIfBotFails: this.autoAssignOperatorIfBotFails
          };

          if (this.bot) {
            payload.botType = this.isAdvancedBot
              ? BOT_TYPE.ADVANCED
              : BOT_TYPE.BASIC;
            if (this.isAdvancedBot) {
              payload.numberOfTrendTopic = this.numberOfTrendTopic;
              payload.numberOfTrendChatAgent = this.numberOfTrendChatAgent;
            }
          }

          const response = await ChatAssignmentRespository.update(payload);
          console.log(payload, 'payload');
        } catch (err) {
          alert(err);
        } finally {
          await this.getAssignment();
        }
      },
      changeBotEnable() {
        if (!this.bot) {
          this.isBasicBot = false;
          this.isAdvancedBot = false;
          this.numberOfTrendTopic = 5;
          this.numberOfTrendChatAgent = 5;
        }
      },
    },
    setup() {
      const permissionType = 'service-setting';
      return { permissionType };
    }
  };
</script>

<style lang="scss" scoped>
  .select-item {
    width: 100%;
    transition: all 0.3s ease;

    @media (min-width: 768px) {
      min-width: 100%;
    }

    @media (min-width: 1500px) {
      min-width: 100%;
      margin: 0 auto;
    }
  }

  label {
    // font-weight: 500;
    margin-bottom: 0.5rem;
  }

  .b-form-input {
    max-width: 100%;
  }

  small.text-muted {
    display: block;
    margin-top: 0.25rem;
  }
</style>
